export default "__VITE_ASSET__Dpegr5BK__"